import { createAction, props } from '@ngrx/store';
import { TaskCategory } from './task-category.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records task category'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records task category success', 
    props<{ listData: TaskCategory[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records task category failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record task category',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record task category success', 
    props<{ singleData: TaskCategory }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record task category failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record task category',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record task category success'
);
export const addRecordFailure = createAction(
    '[Data] Add record task category failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record task category',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record task category success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record task category failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record task category',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record task category success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record task category failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state task category',
);